import React from 'react';
import LoginAuth from '.';
import './index.css';

export default function FullPageLogin({ onSuccess, onClose, redirectUrl, loginEndpoint }) {
  return (
    <div className="login-container">
      <div className="login-popup">
        <button className="login-button" onClick={onClose}>
          ×
        </button>
        <LoginAuth onSuccess={onSuccess} redirectUrl={redirectUrl} loginEndpoint={loginEndpoint} />
      </div>
    </div>
  );
}
